<template>
	<div>
		<template v-if="wrapped">
			<div class="form-group" :class="[colsClass, hasError]">
				<label class="control-label" :for="elementId" v-if="label">{{ label }}</label>
				<slot></slot>
				<span class="help-block" v-if="hasError">{{ errorMessage }}</span>
			</div>
		</template>
		<template v-else>
			<slot></slot>
		</template>
	</div>
</template>

<script>
	import Base from './base';

	export default {
		extends: Base,

		computed: {
			hasError() {
				return this.errorMessage ? 'has-error': null;
			},

			colsClass() {
				return this.cols ? `col-sm-${this.cols}` : null;
			}
		}
	};
</script>

<style scoped>
	label.control-label {
		display: block;
	}
</style>


// WEBPACK FOOTER //
// form-group.vue?6494d76d